var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDecreasingUsage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78033 0.21967C5.48744 -0.0732233 5.01256 -0.0732233 4.71967 0.21967C4.42678 0.512563 4.42678 0.987437 4.71967 1.28033L21.4393 18H18.75C18.3358 18 18 18.3358 18 18.75C18 19.1642 18.3358 19.5 18.75 19.5H23.25C23.6642 19.5 24 19.1642 24 18.75V14.25C24 13.8358 23.6642 13.5 23.25 13.5C22.8358 13.5 22.5 13.8358 22.5 14.25V16.9393L5.78033 0.21967ZM0.75 1.11759e-08C1.16421 1.11759e-08 1.5 0.335786 1.5 0.75V22.5H23.25C23.6642 22.5 24 22.8358 24 23.25C24 23.6642 23.6642 24 23.25 24H0.75C0.335786 24 0 23.6642 0 23.25V0.75C0 0.335786 0.335786 1.11759e-08 0.75 1.11759e-08ZM9.75 10.5C10.1642 10.5 10.5 10.8358 10.5 11.25V18.75C10.5 19.1642 10.1642 19.5 9.75 19.5C9.33579 19.5 9 19.1642 9 18.75V11.25C9 10.8358 9.33579 10.5 9.75 10.5ZM15 15.75C15 15.3358 14.6642 15 14.25 15C13.8358 15 13.5 15.3358 13.5 15.75V16.5V18.75C13.5 19.1642 13.8358 19.5 14.25 19.5C14.6642 19.5 15 19.1642 15 18.75V15.75ZM6 6.75C6 6.33579 5.66421 6 5.25 6C4.83579 6 4.5 6.33579 4.5 6.75V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5C5.66421 19.5 6 19.1642 6 18.75V6.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDecreasingUsage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/decreasing-usage.70682d1d2341296eab392ba780d44d65.svg";